import { BaseComponent } from '@pixelart/component-handler';
import * as scrollmonitor from 'scrollmonitor';
import { ParallaxItem } from './parallax-item.class';
import { ParallaxContainerOptions } from './parallaxContainerOptions.interface';

export class ParallaxContainer extends BaseComponent {
    private config: ParallaxContainerOptions = {
        ELEMENT_SELECTOR: '.parallax-element',
        INITIALIZED_CLASS: 'parallax-container--initialized',
        INTERVAL_MS: 10,
        VISIBLE_CLASS: 'visible',
        distance: 0,
        key: 0,
        minWidth: 0,
        oldTop: -1,
        windowWidth: 0,
    };
    private windowWidth: number;
    private distance: number;
    private minWidth: number;
    private elementWatcher: any;
    private isVisible: boolean;
    private items: ParallaxItem[] = [];

    constructor(element: Element, config?: ParallaxContainerOptions) {
        super(element);
        this.config = (Object as any).assign(this.config, config);
    }

    public init() {
        this.windowWidth = window.innerWidth;
        this.distance = this.$element.data('distance') ? parseInt(this.$element.data('distance'), 10) : 100;
        this.minWidth = this.$element.data('minWidth') ? parseInt(0 + this.$element.data('minWidth'), 10) : 0;

        this.setUpWatchers();

        const $items = this.$element.find(this.config.ELEMENT_SELECTOR);
        $items.each((idx, element) => {
            const parallaxItem = new ParallaxItem(element, { parentDistance: this.distance, key: idx });
            parallaxItem.init();
            this.addItem(parallaxItem);
        });

        this.checkEffect();
        this.setListeners();
        this.$element.addClass(this.config.INITIALIZED_CLASS);
    }

    public checkEffect() {
        if (!this.isVisible) {
            return;
        }

        const boundingRect = this.$element[0].getBoundingClientRect();
        let top = 0;
        if (this.config.windowWidth >= this.config.minWidth) {
            if (this.config.oldTop === boundingRect.top) {
                return;
            }
            this.config.oldTop = boundingRect.top;
            top = boundingRect.top;
        }

        for (const item of this.items) {
            item.setPosition(top);
            item.updatePosition();
        }
    }

    private setUpWatchers() {
        this.elementWatcher = scrollmonitor.create(this.$element);
        this.elementWatcher.enterViewport(this.enterViewPort.bind(this));
        this.elementWatcher.exitViewport(this.exitViewPort.bind(this));
    }

    private enterViewPort() {
        this.$element.addClass(this.config.VISIBLE_CLASS);
        this.isVisible = true;
    }

    private exitViewPort() {
        this.$element.removeClass(this.config.VISIBLE_CLASS);
        this.isVisible = false;
    }

    private addItem(item: ParallaxItem) {
        this.items.push(item);
    }

    private setListeners() {
        $(window).resize(
            () => {
                this.windowWidth = window.innerWidth;
                this.checkEffect();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./assets/components/parallax-content/parallax-container.class.ts